module.exports = __webpack_public_path__ + "media/images/amenities_icons/board_games-20f25bdcff4e44fdd72f85958e24d400.svg";